import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';

const CHUNK_RELOAD_KEY = 'chez-nicu:chunk-reload-attempted';

const isChunkLoadError = (error) => {
  const msg = error?.message || '';
  const name = error?.name || '';

  return (
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    name === 'ChunkLoadError'
  );
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  // Modern React requirement for Error Boundaries
  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo });

    // Recover once from stale dynamic-import chunks after a deployment.
    if (
      typeof window !== 'undefined' &&
      typeof window.sessionStorage !== 'undefined' &&
      isChunkLoadError(error) &&
      !window.sessionStorage.getItem(CHUNK_RELOAD_KEY)
    ) {
      window.sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
      window.location.reload();
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <p>Sorry! Something has gone wrong. Our team has been notified. Refresh Page</p>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundary;
